import React from "react";
import { PENDING } from "../../../../utility/constants/valueConstants";
import "./toggle.css";

const ToggleSwitch = ({
  checked,
  disabled = false,
  onChange,
  style,
  status,
}) => {
  return (
    <div
      style={{
        ...style,
      }}
    >
      <div className="button r" id="button-3">
        <input
          type="checkbox"
          className="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={onChange}
        />
        {/* knobs */}
        <div className={status !== PENDING ? "knobs" : "pending"}></div>
        <div className="layer"></div>
      </div>
    </div>
  );
};

export default ToggleSwitch;
